import styled from 'styled-components';
import { Z_INDEX } from '~/src/styles/tokens/z-index';

export const DomainUrlFieldWrap = styled.div`
    position: absolute;
    z-index: ${Z_INDEX.bottom};
`;
